export default {
    showVariationsModal: {
        copy: 'Kopiér',
        contentVariation: 'Indholdsvariation',
        chosenContent: 'Udvalgt indhold',
        chosenContentPlaceholder: 'Indtast venligst',
        continue: 'Fortsæt',
        generateNewContent: 'Generer nyt indhold',
        type: 'Type:',
        contentTitle: 'Titel:',
        descriptionLabel: 'Beskrivelse:',
        keywordsLabel: 'Nøgleord:',
        writingTone: 'Skrivetone:',
        context: 'Sammenhæng:',
        cancel: 'Annuller',
        emailBuilderTooltip: 'Custom values for sender and recipient is added in the content.',
    },
};
